var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-stream"},[_c('div',{staticClass:"img active",style:({
    backgroundImage: 'url(' + _vm.active.url + '?' + Math.floor(Math.random() * 10000) + ')',
    top: (_vm.active.top || 0),
    left: (_vm.active.left || 0),
    right: (_vm.active.right || 0),
    bottom: (_vm.active.bottom || 0)
  })}),_c('div',{staticClass:"noise"})])
}
var staticRenderFns = []

export { render, staticRenderFns }